export default [
  {
    path: "/first",
    name: "first",
    component: () => import("@/views/pages/about.vue"),
    meta: {
      title: "一级菜单",
      keepAlive: true,
    },
    children: [
      {
        path: "demo",
        name: "firstDemo",
        component: () => import("@/views/pages/demo.vue"),
        meta: {
          title: "只使用组件作为页面布局",
          keepAlive: true,
        },
      },
    ],
  },
  {
    path: "/demo2",
    name: "demo2",
    component: () => import("@/views/pages/demo2.vue"),
    meta: {
      title: "使用组件内置方法",
      keepAlive: true,
    },
  },
  {
    path: "/server",
    name: "server",
    component: () => import("@/views/pages/server.vue"),
    meta: {
      title: "服务器管理",
      keepAlive: true,
    },
  },
  {
    path: "/disk",
    name: "disk",
    component: () => import("@/views/pages/disk.vue"),
    meta: {
      title: "硬盘管理",
      keepAlive: true,
    },
  },
  {
    path: "/port",
    name: "port",
    component: () => import("@/views/pages/port.vue"),
    meta: {
      title: "端口管理",
      keepAlive: true,
    },
  },
  {
    path: "/service",
    name: "service",
    component: () => import("@/views/pages/service.vue"),
    meta: {
      title: "服务管理",
      keepAlive: true,
    },
  },
  {
    path: "/message",
    name: "message",
    component: () => import("@/views/pages/message.vue"),
    meta: {
      title: "消息管理",
      keepAlive: true,
    },
  },
  {
    path: "/messageConfig",
    name: "messageConfig",
    component: () => import("@/views/pages/messageConfig.vue"),
    meta: {
      title: "消息配置",
      keepAlive: true,
    },
  },
  {
    path: "/messageServer",
    name: "messageServer",
    component: () => import("@/views/pages/messageServer.vue"),
    meta: {
      title: "消息服务",
      keepAlive: true,
    },
  },
];
